import { Injectable } from '@angular/core';
import { LocalStorageKey } from '../login';
import { Observable } from 'rxjs';
import { API } from '../config/api';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
    public baseUrl = environment.baseUrl;
    constructor(private _http: HttpClient,
        private router: Router) {
    }

    public get IsAuthenticate() {
        // Validate token
        const token = localStorage.getItem(LocalStorageKey.Token);
        return token && token !== '';
    }

    public GetAccessToken(): string {
        return localStorage.getItem(LocalStorageKey.Token);
    }

    public getCurrentUser(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.LOGIN.GET_CURRENT_USER}`);
    }

    public validateToken(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.LOGIN.VALIDATE_TOKEN}`);
    }

    public logout() {
        this.clearToken();
        this.router.navigateByUrl('login');
    }

    public clearToken() {
        localStorage.removeItem(LocalStorageKey.Token);
        localStorage.removeItem(LocalStorageKey.CurrentUser);
    }
}
